import type { PostCompanyOrderPeriodRequestEntity } from "./PostCompanyOrderPeriodRequestEntity"

export class CompanyPeriodsEntity {
  periods?: PostCompanyOrderPeriodRequestEntity[]
}